import React from 'react'
import ICONS from '../../../assets/icons'

export const type = [
  {
    text: 'Daily',
    value: 'D1',
  },
  {
    text: 'Weekly',
    value: 'D7',
  },
  {
    text: 'Fortnightly',
    value: 'F1',
  },
  {
    text: 'Monthly',
    value: 'M1',
  },
  {
    text: 'Bi-Monthly',
    value: 'M2',
  },
  {
    text: 'Quarterly',
    value: 'M3',
  },
  {
    text: 'Four Monthly',
    value: 'M4',
  },
  {
    text: 'Half Yearly',
    value: 'M6',
  },
  {
    text: 'Annual',
    value: 'Y1',
  },
  {
    text: '2 Yearly',
    value: 'Y2',
  },
  {
    text: '3 Yearly',
    value: 'Y3',
  },
  {
    text: '4 Yearly',
    value: 'Y4',
  },
  {
    text: '5 Yearly',
    value: 'Y5',
  },
  {
    text: '6 Yearly',
    value: 'Y6',
  },
];

export const status = [
  {
    text: 'Open',
    value: 'open',
    icon: <ICONS.arrowUpRight/>,
  },
  {
    text: 'Complete',
    value: 'completed',
    icon: <ICONS.checkCircle/>,
  },
  {
    text: 'Incomplete',
    value: 'incomplete',
    icon: <ICONS.x />,
  }
];

export const period = [
  {
    periodCode: 'today',
    text: 'Today',
  },
  {
    periodCode: 'thisWeek',
    text: 'Current Week',
  },
  {
    periodCode: 'thisMonth',
    text: 'Current Month',
  },
  {
    periodCode: 'last3Months',
    text: 'Last 3 Months',
  },
  {
    periodCode: 'last6Months',
    text: 'Last 6 Months',
  },
];